<nav class="float-left">
    <ul>
        <li>
            <a class="fontSizeElements" href="javascript:void(0)">
                SOC - 2.1.0
            </a>
        </li>
    </ul>
</nav>
<div class="copyright float-right fontSizeElements">
    &copy;
    {{ date| date:'yyyy' }}
</div>
